function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';

var Spinner = /*#__PURE__*/function () {
  function Spinner() {
    _classCallCheck(this, Spinner);
  }

  _createClass(Spinner, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-spinner', {
        name: 'roche-spinner',
        template: "\n        <div class=\"roche-spinner\" :class=\"{'is-padded': padding}\">\n          <div class=\"roche-spinner--dot\"></div>\n          <div class=\"roche-spinner--dot\"></div>\n          <div class=\"roche-spinner--dot\"></div>\n        </div>\n      ",
        props: {
          padding: {
            type: Boolean,
            "default": false
          }
        }
      });
    }
  }]);

  return Spinner;
}();

export default Spinner;